import apiClient from '@/services/axios.js';
import router from '@/router';
import {useUserStore} from '@/stores/user.js';

// Default handleCredentialExpired
function defaultHandleCredentialExpired(errorMessage = 'Your credential is expired') {
  useUserStore().resetUser(errorMessage);
  console.log('defaultHandleCredentialExpired');
  return false;
}

// Default handleFailure
function defaultHandleFailure(errorMessage) {
  useUserStore().setErrorMessage(errorMessage);
  console.log('defaultHandleFailure');
  return false;
}

export async function useApi(
  request,
  handleSuccess,
  handleCredentialExpired = (errorMessage) => defaultHandleCredentialExpired(errorMessage),
  handleFailure = (errorMessage) => defaultHandleFailure(errorMessage)) {
  try {
    const response = await apiClient.post('', request);
    if (response.data.response === 100) {
      return handleSuccess(response);
    } else if (response.data.response === -100002) {
      await router.push({name: 'Login'});
      return handleCredentialExpired('Your credential is expired');
    } else if (response.data.response === -102) {
      await router.push({name: 'Login'});
      return handleCredentialExpired("Login session has expired. You should login again.");
    } else {
      return handleFailure(response.data.message);
    }
  } catch (err) {
    const error = err.response ? err.response.data.message : err.message;
    console.log(err);
    return handleFailure(error);
  } finally {
    const loading = false;
  }
}
